import React from 'react';

function SelectColumnFilter({ column: { filterValue, setFilter, preFilteredRows, id } }) {
    // 获取所有唯一值
    const options = React.useMemo(() => {
        const uniqueOptions = new Set();
        preFilteredRows.forEach((row) => {
            uniqueOptions.add(row.values[id]);
        });
        return [...uniqueOptions];
    }, [id, preFilteredRows]);

    return (
        <select
            value={filterValue || ''}
            onChange={(e) => setFilter(e.target.value || undefined)} // 设置过滤值
        >
            <option value="">全部</option>
            {options.map((option, i) => (
                <option key={i} value={option}>
                    {option}
                </option>
            ))}
        </select>
    );
}

export default SelectColumnFilter;